/* eslint-disable camelcase */
/* eslint operator-linebreak: 0 */
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { showPopconfirm } from '../comps/Popconfirm';
import { getOffsetRect, makeEffectStub, vueDeepAssign } from "../../lib/utils";
import { DND_TYPE_DATA_PATH, INJECT_UICORE_BUS, INJECT_UICORE_DESIGNER, SELECTOR_DESIGNER_INTERACTIVE_DROPZONE_ELEMENT, CTRL_KEY, IS_MAC, SELECTOR_DESIGNER_INTERACTIVE_ELEMENT } from "../../lib/utils/consts";
import { elt, highlightRect } from "../../lib/utils/browser";
import { isSuitableForBinding } from "../../lib/utils/bindings";
import makeSchmittTrigger from "../../lib/utils/makeSchmittTrigger";
import shallowEqual from "../../lib/utils/shallowEqual";
import { isInsideRect, rect2css } from "../../lib/utils/styling";
import { getSlotFromElement, getVNodeFactoryState } from '../renderer/utils';
import { throttle } from "lodash-es";
import { deepCompPathCapture } from './utils/compCapture';
import { invokeFitDataOnApply } from './utils/invokeCallbacks';
const isTargetIgnored = (ev, senario = 'normal') => {
  const target = ev.target;
  const selector = senario === 'drag' ? SELECTOR_DESIGNER_INTERACTIVE_DROPZONE_ELEMENT : SELECTOR_DESIGNER_INTERACTIVE_ELEMENT;
  if (!target || typeof target.matches !== 'function' || target.matches(selector)) return true;
  return false;
};
let EditZoneState = class EditZoneState extends Vue {
  constructor() {
    super(...arguments);
    this.compSkeletons = new Set();
    /** 按住alt键进入inspect模式 */
    this.inspecting = false;
    // #region 编辑期间，鼠标悬浮在 scopedSlot 实例
    this.hoveringScopedSlotInfo = null;
    this.removeIndicator = null;
    this.currentActiveSlot = null;
    this.activeCompSkeleton = undefined;
    this.cursorClientX = 0;
    this.cursorClientY = 0;
    // #region 编辑期间，拖拽绑定数据源
    this.bindingHoveringCompPath = '';
    /** 当前是否是按着 ctrl 键（复制）拖拽的 */
    this.currentDraggingToCopy = false;
    /** 拖拽期间放置到哪里 */
    this.targetSlotInfo = null;
    /** 当前要放置的放置点，由 TargetSlotSkeleton 维护 */
    this.currentDropHint = null;
    // #endregion
    /** 累加多帧的滚动值 */
    this.scrollTotal = 0;
    /** 防止超快的鼠标滚轮 */
    this.changeZoomThrottle = throttle(deltaScroll => this.designer.addToZoom(deltaScroll), 200);
  }
  get editZone() {
    return this.designer.$refs.editZone;
  }
  created() {
    this.$watch(() => this.designer.isDragging, d => {
      if (!d) this.currentDropHint = null;
    });
    this.$watch(() => this.bindingHoveringCompPath, (bindingHoveringCompPath, lastBindingHoveringCompPath) => {
      this.designer.setHighlight(bindingHoveringCompPath, 'normal');
      this.designer.setHighlight(lastBindingHoveringCompPath, false);
    });
    this.$watch(() => {
      var _this$designer$render;
      return [(_this$designer$render = this.designer.renderer) === null || _this$designer$render === void 0 ? void 0 : _this$designer$render.ucVNodeFactory, this.designer.compPath];
    }, () => {
      this.currentActiveSlot = null;
    });
    const activeSlotMaskText = elt('div', {
      class: 'ucd-editZone-slotIndicator-text'
    });
    const activeSlotMask = elt('div', {
      class: 'ucd-editZone-slotIndicator'
    }, [activeSlotMaskText]);
    const displayActiveSlot = makeEffectStub(el => {
      if (!el) return;
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const slot = this.currentActiveSlot;
      const {
        style,
        offsetParent
      } = getMaskStyle(this.designer, el);
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const layoutName = this.uc.getLayoutName(this.designer.activeComp, {
        omitId: true
      });
      Object.assign(activeSlotMask.style, style);
      // activeSlotMaskText.textContent = `[ ${layoutName} - ${slot.id} 槽位 ]`;
      offsetParent.appendChild(activeSlotMask);
      return () => {
        activeSlotMask.remove();
      };
    });
    this.$watch(() => {
      var _this$currentActiveSl, _this$currentActiveSl2;
      return (_this$currentActiveSl = this.currentActiveSlot) === null || _this$currentActiveSl === void 0 || (_this$currentActiveSl2 = _this$currentActiveSl.getSlotContainerElement) === null || _this$currentActiveSl2 === void 0 ? void 0 : _this$currentActiveSl2.call(_this$currentActiveSl);
    }, displayActiveSlot);
    this.$once('hook:beforeDestroy', () => displayActiveSlot(null));
    this.handleEditZoneDragOver_bindingThrottle = throttle(ev => this.handleEditZoneDragOver_binding(ev), 16);
  }
  handleScopedSlotMouseMove(ev, info) {
    var _this$removeIndicator;
    if (info.slotMeta.frozen) return;
    if (this.hoveringScopedSlotInfo && this.hoveringScopedSlotInfo.subCRenderer === info.subCRenderer) {
      return;
    }
    // 作用域插槽的 indicator 会直接注入到真实 DOM 里面
    const {
      offsetParent,
      style
    } = getMaskStyle(this.designer, info.subCRenderer.$el, ev.currentTarget.offsetParent);
    const removeIndicator = () => {
      var _indicator$parentElem;
      this.hoveringScopedSlotInfo = null;
      (_indicator$parentElem = indicator.parentElement) === null || _indicator$parentElem === void 0 || _indicator$parentElem.removeChild(indicator);
      this.removeIndicator = null;
    };
    const enterScope = ev => {
      ev.preventDefault();
      removeIndicator();
      this.designer.enterScopedSlot({
        renderer: info.subCRenderer,
        compPath: info.ownerCompPath,
        slotId: info.slotMeta.id,
        prevCompPath: info.ownerCompPath
      });
    };
    this.hoveringScopedSlotInfo = info;
    const indicator = elt('div', {
      style,
      class: 'ucd-editZone-scopedSlotIndicator',
      'data-uc-scoped-slot-id': info.slotMeta.id,
      'data-uc-scoped-slot-owner': info.ownerCompPath,
      'uc-designer-interactive': true,
      onMouseleave: removeIndicator,
      onDblclick: enterScope,
      onMousedown: ev => {
        if (ev.button === 2) return; // 右键
        if (this.designer.compPath !== info.ownerCompPath) {
          this.designer.compPath = info.ownerCompPath;
        }
      },
      onMousemove: () => {
        // 向上冒泡时，修正鼠标所在的组件 path 为插槽 owner
        this.tempHoveringCompPath = info.ownerCompPath;
      }
    }, [elt('div', {
      class: 'ucd-fullCoverDesignTool'
    }, [elt('div', {
      class: 'ucd-fullCoverDesignTool-content ucd-editZone-slotIndicator-text'
    }, ['双击编辑区域内的布局'])])]);
    offsetParent.appendChild(indicator);
    (_this$removeIndicator = this.removeIndicator) === null || _this$removeIndicator === void 0 || _this$removeIndicator.call(this);
    this.removeIndicator = removeIndicator;
  }
  /**
   * 移动元素到 editZone 里，并且调整它的位置遮住一个 target。
   *
   * 注意：这个元素必须有 position: absolute 并且你要自行处理 mouseleave 事件，将自己 remove
   */
  placeMask(el, maskTarget) {
    const {
      offsetParent,
      style
    } = getMaskStyle(this.designer, maskTarget);
    offsetParent.appendChild(el);
    Object.assign(el.style, style);
  }
  // #endregion
  handleEditZoneContextMenu(ev) {
    var _designer$activeCompI, _designer$activeCompI2;
    ev.preventDefault();
    const {
      designer
    } = this;
    const elRect = (_designer$activeCompI = designer.activeCompInstance) === null || _designer$activeCompI === void 0 || (_designer$activeCompI = _designer$activeCompI.$el) === null || _designer$activeCompI === void 0 || (_designer$activeCompI2 = _designer$activeCompI.getBoundingClientRect) === null || _designer$activeCompI2 === void 0 ? void 0 : _designer$activeCompI2.call(_designer$activeCompI);
    if (elRect && !isInsideRect(ev.clientX, ev.clientY, elRect)) {
      highlightRect(elRect);
    }
    designer.openContextMenuForActiveComp(ev);
  }
  handleCanvasMouseMoveCaptureStart() {
    this.tempHoveringCompPath = '';
  }
  handleComponentMouseMoveCapture(ev, compPath) {
    this.tempHoveringCompPath = compPath;
  }
  handleCanvasOutsideClick() {
    this.currentActiveSlot = null;
  }
  handleCanvasMouseMoveCaptureEnd(ev) {
    this.lastMousePos = {
      clientX: ev.clientX,
      clientY: ev.clientY
    };
    const newCompPath = deepCompPathCapture(this.tempHoveringCompPath, ev, this.designer);
    // ------------------------
    if (this.designer.hoveringCompPath !== newCompPath) {
      this.designer.hoveringCompPath = newCompPath;
    }
  }
  handleComponentNativeEventCapture(e) {
    // 允许部分组件事件穿透
    if (!isTargetIgnored(e)) {
      e.stopPropagation();
      // e.preventDefault();
    }
  }
  handleComponentNativeMouseDownCapture(e) {
    this.editZoneMouseDown = true;
    this.handleComponentNativeEventCapture(e);
  }
  handleComponentNativeMouseUpCapture(e) {
    // 只处理左键选中组件 并且需要是从editZone发起的mouseDown
    if (e.button !== 2 && this.editZoneMouseDown) {
      const {
        hoveringCompPath
      } = this.designer;
      // 然后是选中组件 or 退出作用域
      if (hoveringCompPath !== this.designer.compPath) {
        this.currentActiveSlot = null;
        this.designer.compPath = hoveringCompPath;
      } else {
        // 仍然在点击这个组件，看看他点击的是哪个插槽
        const currentSlot = getSlotFromElement(this.designer.renderer, hoveringCompPath, e.target);
        const lastCurrentSlot = this.currentActiveSlot;
        if (!lastCurrentSlot || lastCurrentSlot.id !== (currentSlot === null || currentSlot === void 0 ? void 0 : currentSlot.id)) {
          this.currentActiveSlot = currentSlot && Object.freeze({
            ...currentSlot
          });
        } else {
          this.currentActiveSlot = null;
        }
        if (!this.currentActiveSlot && !isTargetIgnored(e) && hoveringCompPath === '' && this.designer.scopeStack.length) {
          // 当前是编辑作用域插槽，要回退上一个级别
          // 但是要注意 isTargetIgnored，避免退出了作用域
          this.currentActiveSlot = null;
          this.designer.exitScope();
        }
      }
    }
    this.editZoneMouseDown = false;
    if (isTargetIgnored(e)) return;
    this.handleComponentNativeEventCapture(e);
    this.$nextTick(() => {
      this.editZone.focus();
    });
  }
  handleComponentNativeFocusCapture(e) {
    this.handleComponentNativeEventCapture(e);
  }
  // #endregion
  /** 当前正在被拖拽调整位置的组件，如果不是调整位置（比如复制、从组件库拖出），则为 null */
  get currentDraggingCompPath() {
    var _this$designer$dragSo;
    return !this.currentDraggingToCopy && ((_this$designer$dragSo = this.designer.dragSource) === null || _this$designer$dragSo === void 0 ? void 0 : _this$designer$dragSo.oldCompPath) || null;
  }
  handleCanvasDragStartCapture(ev) {
    var _this$editZone$$refs$, _this$activeCompSkele;
    if (isTargetIgnored(ev, 'drag')) return;
    ev.stopPropagation();
    // eslint-disable-next-line max-len
    this.activeCompSkeleton = (_this$editZone$$refs$ = this.editZone.$refs.compSkeletons) === null || _this$editZone$$refs$ === void 0 ? void 0 : _this$editZone$$refs$.find(x => x.isSelected);
    if (!((_this$activeCompSkele = this.activeCompSkeleton) !== null && _this$activeCompSkele !== void 0 && _this$activeCompSkele.startDraggingBlock(ev))) {
      // 如果启动拖拽失败，就 prevent default
      ev.preventDefault();
    }
  }
  handleCanvasDragEndCapture(ev) {
    if (this.activeCompSkeleton) {
      this.activeCompSkeleton.stopDraggingBlock(ev);
      this.activeCompSkeleton = undefined;
    }
  }
  handleEditZoneDragOverCapture(ev) {
    if (isTargetIgnored(ev, 'drag')) return;
    this.isDraggingOver = true;
    ev.preventDefault();
    ev.stopPropagation();
    const {
      currentOperation
    } = this.designer;
    if (currentOperation === 'dragging') this.handleEditZoneDragOver_dragging(ev);
    if (currentOperation === 'binding') this.handleEditZoneDragOver_bindingThrottle(ev);
  }
  handleEditZoneDragLeaveCapture() {
    const {
      currentOperation
    } = this.designer;
    this.isDraggingOver = false;
    if (currentOperation === 'binding') this.handleEditZoneDragLeave_binding();
  }
  handleEditZoneDropCapture(ev) {
    ev.stopPropagation();
    ev.preventDefault();
    this.isDraggingOver = false;
    const {
      currentOperation
    } = this.designer;
    if (currentOperation === 'dragging') this.handleEditZoneDrop_dragging();
    if (currentOperation === 'binding') this.handleEditZoneDrop_binding(ev);
  }
  // eslint-disable-next-line @typescript-eslint/naming-convention
  handleEditZoneDragOver_binding(ev) {
    if (this.designer.currentOperation !== 'binding') return;
    const bindableCheck = ({
      componentMeta: compMeta
    }) => {
      var _compMeta$bindings;
      if (compMeta !== null && compMeta !== void 0 && (_compMeta$bindings = compMeta.bindings) !== null && _compMeta$bindings !== void 0 && _compMeta$bindings.length) return true;
      if (compMeta !== null && compMeta !== void 0 && compMeta.bindingAction) return true;
      return false;
    };
    this.cursorClientX = ev.clientX;
    this.cursorClientY = ev.clientY;
    const compPath = this.designer.compFromPoint(ev.clientX, ev.clientY, bindableCheck);
    this.bindingHoveringCompPath = compPath;
  }
  // eslint-disable-next-line @typescript-eslint/naming-convention
  handleEditZoneDragLeave_binding() {
    this.handleEditZoneDragOver_bindingThrottle.cancel();
    if (this.designer.currentOperation !== 'binding') return;
    this.bindingHoveringCompPath = '';
  }
  // eslint-disable-next-line @typescript-eslint/naming-convention
  handleEditZoneDrop_binding(ev) {
    this.handleEditZoneDragOver_bindingThrottle.flush();
    if (this.designer.currentOperation !== 'binding') return;
    const bindingDataPath = ev.dataTransfer.getData(DND_TYPE_DATA_PATH);
    const {
      bindingHoveringCompPath
    } = this;
    if (bindingDataPath && bindingHoveringCompPath) {
      this.designer.compPath = bindingHoveringCompPath;
      console.log('linking', bindingHoveringCompPath, bindingDataPath);
      this.cursorClientX = ev.clientX;
      this.cursorClientY = ev.clientY;
      this.executeBinding(bindingHoveringCompPath, bindingDataPath);
    }
    this.bindingHoveringCompPath = '';
  }
  /**
   * 鼠标放开时，执行绑定，如果有多个可绑定的 prop，会在UI上提示用户做选择
   */
  async executeBinding(compPath, dataPath) {
    const defaultBindingAction = async ({
      comp,
      compMeta,
      dataPath,
      designer,
      uc
    }) => {
      var _designer$renderer, _compMeta$bindings2;
      const dataStub = (_designer$renderer = designer.renderer) === null || _designer$renderer === void 0 ? void 0 : _designer$renderer.getStubAtPath(dataPath);
      if (!dataStub) return;
      const bindings = compMeta === null || compMeta === void 0 || (_compMeta$bindings2 = compMeta.bindings) === null || _compMeta$bindings2 === void 0 ? void 0 : _compMeta$bindings2.filter(x => isSuitableForBinding(x, dataStub.schema));
      if (!(bindings !== null && bindings !== void 0 && bindings.length)) {
        uc.$message.warn('不能绑定当前数据源到此组件');
        return;
      }
      let binding = bindings[0];
      if (!binding) return;
      // 有多个可选的 bindings
      if (bindings.length > 1) {
        const existingBindings = comp.bindings || {};
        binding = await showPopconfirm(this, {
          content: `请问要将数据 ${dataPath} 绑定到什么上？`,
          clientX: this.cursorClientX,
          clientY: this.cursorClientY,
          options: bindings.map(x => ({
            label: x.title || x.id,
            value: x,
            primary: !(x.id in existingBindings)
          }))
        });
        if (!binding) return; // 取消了绑定
      }
      vueDeepAssign(comp, {
        bindings: {
          [binding.id]: dataPath
        }
      });
      uc.$message.success(`已绑定组件的 ${binding.id} 到：${dataPath}`);
    };
    await this.designer.modifyComp(compPath, async comp => {
      var _this$uc$components$c;
      const compMeta = (_this$uc$components$c = this.uc.components[comp === null || comp === void 0 ? void 0 : comp.type]) === null || _this$uc$components$c === void 0 ? void 0 : _this$uc$components$c.meta;
      if (!compMeta) return;
      await (compMeta.bindingAction || defaultBindingAction)({
        comp,
        dataPath,
        compMeta,
        compPath,
        designer: this.designer,
        uc: this.uc
      });
    });
  }
  // eslint-disable-next-line @typescript-eslint/naming-convention
  handleEditZoneDragOver_dragging(ev) {
    var _this$designer$dragSo2;
    if (this.designer.currentOperation !== 'dragging') return;
    const {
      clientX,
      clientY
    } = ev;
    const target = ev.target;
    ev.dataTransfer.dropEffect = ev.ctrlKey && ev.dataTransfer.effectAllowed.includes('copy') ? 'copy' : 'move';
    this.currentDraggingToCopy = !!((_this$designer$dragSo2 = this.designer.dragSource) !== null && _this$designer$dragSo2 !== void 0 && _this$designer$dragSo2.oldCompPath && ev.dataTransfer.dropEffect === 'copy');
    /** 拖拽时，当前被选中的组件，不能被放到当前组件里面（ 避免不可能套娃 ） */
    const forbiddenDropTarget = this.currentDraggingToCopy ? '' : this.currentDraggingCompPath;
    const forbiddenDropTargetPrefix = forbiddenDropTarget ? `${forbiddenDropTarget}/` : '';
    // --------------- 按 Shift 可以切换不同的放置点
    // 由于 keydown 事件在拖拽期间无法触发，因此这里靠两个变量，判断 ev.shiftKey 是否发生了变化
    if (!this.alternateCounter || Math.abs(this.alternateOriginX - ev.clientX) + Math.abs(this.alternateOriginY - ev.clientY) > 10) {
      this.alternateCounter = 0;
      this.alternateOriginX = ev.clientX;
      this.alternateOriginY = ev.clientY;
    }
    if (!this.alternatePressingShift && ev.shiftKey) {
      // 按了一下 Shift
      this.alternateCounter += 1;
    }
    this.alternatePressingShift = ev.shiftKey;
    // -----------------------------------------------
    if (!this.dragOverCaptureRAF) {
      this.dragOverCaptureRAF = requestAnimationFrame(() => {
        var _this$targetSlotInfo;
        this.dragOverCaptureRAF = 0;
        this.cursorClientX = clientX;
        this.cursorClientY = clientY;
        const renderer = this.designer.renderer;
        // 1. 找到鼠标落在的容器组件 & 插槽 -----------------------------------------
        let found = false;
        let compInstance;
        let compPath;
        let slotContainerElement;
        let slotMeta;
        let discardMatchTimes = this.alternateCounter || 0;
        let iElement = target;
        let iSearchStartPoint = iElement;
        // 首先要注意，可能 dragover 事件可能被外面什么东西拦截了，比如 DesignTool，那就要稍微麻烦点去寻找实际点组件
        const rendererCanvasEl = this.editZone.$refs.rendererCanvas;
        if (!rendererCanvasEl.contains(iElement)) {
          iElement = document.elementsFromPoint(ev.clientX, ev.clientY).find(x => rendererCanvasEl.contains(x) || x.matches(`[data-uc-renderer-uuid="${renderer.ucRendererUUID}"] *`));
          iSearchStartPoint = iElement;
        }
        // 然后向上冒泡寻找组件
        for (; !!iElement; iElement = iElement.parentElement) {
          var _getVNodeFactoryState;
          // 如果是 canvas 区实际渲染出来的组件，那么要先判断是不是当前作用域的。
          const acceptableTarget = iElement.getAttribute('data-uc-renderer-uuid') === renderer.ucRendererUUID;
          if (!acceptableTarget) continue;
          const tempCompPath = iElement.getAttribute('data-uc-path');
          if (typeof tempCompPath !== 'string') continue;
          const tempInstance = renderer.getRefByPath(tempCompPath);
          if (!(tempInstance !== null && tempInstance !== void 0 && tempInstance.$el) || iElement !== tempInstance.$el) continue;
          // 然后需要特色过滤条件
          // 当前在拖拽的组件，如果不是 copy，就不能放到自己的子组件里
          if (forbiddenDropTarget && (tempCompPath === forbiddenDropTarget || tempCompPath.startsWith(forbiddenDropTargetPrefix))) {
            continue;
          }
          // 找到了当前鼠标落在哪个组件，接下来判断是在哪个插槽
          // 插槽实例有两个来源： <uc-slot /> 以及 meta 里声明的 slots
          let iSlotContainerElement;
          let iSlotMeta;
          let foundSlot = false;
          // #region 搜索插槽容器 ----------------------
          const allNormalSlots = (_getVNodeFactoryState = getVNodeFactoryState(renderer, tempCompPath)) === null || _getVNodeFactoryState === void 0 ? void 0 : _getVNodeFactoryState.getNormalSlots();
          for (let i = 0; allNormalSlots && i < allNormalSlots.length; i++) {
            var _slot$getSlotContaine;
            const slot = allNormalSlots[i];
            const tempContainer = slot === null || slot === void 0 || (_slot$getSlotContaine = slot.getSlotContainerElement) === null || _slot$getSlotContaine === void 0 ? void 0 : _slot$getSlotContaine.call(slot);
            if (!tempContainer) continue;
            if (!(tempContainer === iSearchStartPoint || tempContainer.contains(iSearchStartPoint))) continue;
            iSlotContainerElement = tempContainer;
            iSlotMeta = slot;
            foundSlot = true;
            break;
          }
          // #endregion ----------------------
          if (!foundSlot) continue; // 没有落当前组件的插槽里，就继续搜索上层的
          if (discardMatchTimes) {
            // 按过 shift 键，要抛弃当前匹配的结果
            discardMatchTimes -= 1;
            continue;
          }
          found = true;
          compInstance = tempInstance;
          compPath = tempCompPath;
          slotContainerElement = iSlotContainerElement;
          slotMeta = iSlotMeta;
          break;
        }
        if (!found) {
          // 目前鼠标没落在任何有效的插槽
          this.alternateCounter = 0;
          if (this.targetSlotInfo) this.targetSlotInfo = null;
          return;
        }
        // 2. 更新插槽的情况 ------------------------------------------------------
        const temp = {
          compInstance: compInstance,
          compPath: compPath,
          slotContainerElement: slotContainerElement,
          slotMeta: slotMeta
        };
        const isSameSlot = shallowEqual({
          ...temp,
          slotMeta: null
        }, {
          ...this.targetSlotInfo,
          slotMeta: null
        }) && shallowEqual({
          ...temp.slotMeta,
          getSlotContainerElement: null
        }, {
          ...((_this$targetSlotInfo = this.targetSlotInfo) === null || _this$targetSlotInfo === void 0 ? void 0 : _this$targetSlotInfo.slotMeta),
          getSlotContainerElement: null
        });
        if (!isSameSlot) {
          this.targetSlotInfo = Object.freeze(temp);
        }
      });
    }
  }
  // eslint-disable-next-line @typescript-eslint/naming-convention
  async handleEditZoneDrop_dragging() {
    if (this.dragOverCaptureRAF) {
      cancelAnimationFrame(this.dragOverCaptureRAF);
      this.dragOverCaptureRAF = 0;
    }
    if (this.designer.currentOperation !== 'dragging') return;
    try {
      var _this$currentDropHint;
      // ---------------------------
      const {
        targetSlotInfo: aboutDropTo
      } = this;
      if (!aboutDropTo) return;
      // ---------------------------
      const currentDropHint = this.currentDropHint;
      const targetSlotSkeleton = currentDropHint.ownerSlot;
      const executeArgs = {
        clientX: this.cursorClientX,
        clientY: this.cursorClientY,
        offsetX: this.cursorClientX - targetSlotSkeleton.slotClientX,
        offsetY: this.cursorClientY - targetSlotSkeleton.slotClientY,
        slotWidth: targetSlotSkeleton.slotWidth,
        slotHeight: targetSlotSkeleton.slotHeight,
        slotContainerElement: targetSlotSkeleton.slotContainerElement
      };
      await ((_this$currentDropHint = this.currentDropHint) === null || _this$currentDropHint === void 0 ? void 0 : _this$currentDropHint.execute(executeArgs));
      await this.designer.processAfterDrop(executeArgs);
      this.editZone.focus();
      this.$nextTick(() => {
        const {
          currentDraggingFitDataResult
        } = this;
        if (!currentDraggingFitDataResult) return;
        invokeFitDataOnApply({
          scene: (currentDraggingFitDataResult === null || currentDraggingFitDataResult === void 0 ? void 0 : currentDraggingFitDataResult.scene) || 'drag',
          compPath: this.designer.compPath,
          designer: this.designer,
          uc: this.uc,
          renderer: this.designer.renderer,
          entityParams: this.currentDraggingEntityFitDataParams
        }, currentDraggingFitDataResult);
        this.currentDraggingFitDataResult = void 0;
        this.currentDraggingEntityFitDataParams = void 0;
      });
    } finally {
      this.targetSlotInfo = null;
    }
  }
  /** cmd/ctrl+鼠标滚轮 / 触摸板缩放 调整编辑器缩放等级 */
  handleEditZoneWheelZoom(ev) {
    // 触摸板事件发送频率高 但是滚动数值小 考虑到平滑使用应该累加滚动数值达到阈值后进行缩放结算
    // windows: ctrl+滚轮  macos: cmd+滚轮 macos触摸板: ctrl+滚轮
    const isMacOsTouchPad = IS_MAC && !ev.cancelable && ev.ctrlKey;
    if (ev[CTRL_KEY] || isMacOsTouchPad) {
      // 缩放按键组合暂时不对应别的逻辑了 直接拦截
      ev.preventDefault();
      this.scrollTotal -= ev.deltaY;
      if (Math.abs(this.scrollTotal) > 10) {
        // TODO: 暂定积累10结算一次 不知道灵敏度有没有标准值需要调研
        // 将scrollTotal (-∞,-10)∪(10,+∞) 限定为 -10 || 10
        const deltaScroll = this.scrollTotal > 0 ? 10 : -10;
        // 滚动一档 是进行10%缩放
        this.changeZoomThrottle(deltaScroll);
        // 清除滚动累计
        this.scrollTotal = 0;
      }
    }
  }
  handleScroll() {
    // 用于给页面子组件通知滚动事件
    if (this.designer.zoom !== 100) {
      this.$emit('scroll');
    }
  }
};
EditZoneState = __decorate([Component({
  name: 'EditZoneState',
  data() {
    return {
      internalIsDraggingOver: false
    };
  },
  computed: {
    isDraggingOver: makeSchmittTrigger('internalIsDraggingOver', 200)
  },
  inject: {
    uc: {
      from: INJECT_UICORE_BUS
    },
    designer: {
      from: INJECT_UICORE_DESIGNER
    }
  }
})], EditZoneState);
export { EditZoneState };
function getMaskStyle(designer, el, preferredOffsetParent) {
  const offsetParent = preferredOffsetParent || designer.$refs.editZone.$refs.rendererCanvas;
  const rect = getOffsetRect(el, offsetParent);
  // 鼠标选中之后 蓝色的框框大小 按照缩放重新修正大小
  const zoomPercentage = designer.getZoomPercentage();
  rect.height /= zoomPercentage;
  rect.width /= zoomPercentage;
  rect.x /= zoomPercentage;
  rect.y /= zoomPercentage;
  return {
    rect,
    offsetParent,
    style: rect2css(rect)
  };
}
export default EditZoneState;
//# sourceMappingURL=EditZoneState.js.map
